import React, { useState ,useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Multiselect from "multiselect-react-dropdown";
import validator from "validator";

import {setAdminuseraccesslistDatasgetlistActions ,resetMasterdashData_Crud_opretions} from "../../../Redux/Slice"
import { useDispatch, useSelector } from "react-redux";

export const Mastercruds = (props) => {
  const { retrievedata, show, setShow , search , dtpageindex } = props;
  const [viewpass, setViewpass] = useState(false);
  const [errors, setErrors] = useState({});

  const state = useSelector((state)=>state);
  const dispatch = useDispatch()

  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    admin_access: [],
    is_active: true,
  }); 
  console.log(retrievedata,"retrievedata");
  

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [optionsForAdim, setOPtionAdmin] = useState([]);

  const optionsForAdmin = [
    { name: "ONBOARDING", value: "onboarding" },
    { name: "JOBPORTAL", value: "jobportal" },
    { name: "UDESK", value: "udesk" },
    { name: "INVOICE", value: "invoice" },
    { name: "WORKFLOW", value: "workflow" },
    { name: "INCONN", value: "inconn" },
  ];

 

  // ✅ Populate data from retrievedata
  useEffect(() => {
    if (retrievedata) {
      setData({
        first_name: retrievedata.first_name || "",
        last_name: retrievedata.last_name || "",
        email: retrievedata.email || "",
        password: "", // ⚠️ Don't populate hashed password
        admin_access: retrievedata.admin_access || [],
        is_active: retrievedata.is_active ?? true,
      });

      // Preselect values in Multiselect
      setSelectedOptions(
        (retrievedata.admin_access || []).map((x) => ({
            value: x,
            name: x.toUpperCase(),

        }))
      );
    }
  }, [retrievedata]);


  // ✅ Handle input changes & remove error for that field
  const HandleChanges = (e) => {
    const { name, value } = e.target;

    let newValue = value;
    if (name !== "email" && value.length > 0) {
      newValue = value.charAt(0).toUpperCase() + value.slice(1);
    }

    setData({ ...data, [name]: newValue });

    // remove error for that field
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  // ✅ Handle multi-select changes & remove error
  const handleChange = (selectedList) => {    
    setSelectedOptions(selectedList);
    setData({ ...data, admin_access: selectedList.map((s) => s.value) });

    if (errors.admin_access) {
      setErrors({ ...errors, admin_access: "" });
    }
  };

  // ✅ Password validation
  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return regex.test(password);
  };

const validateForm = () => {
  let tempErrors = {};

  if (!data.first_name.trim()) tempErrors.first_name = "First name is required";
  if (!data.last_name.trim()) tempErrors.last_name = "Last name is required";
  if (!data.email.trim()) tempErrors.email = "Email is required";

      if (data.password && !validatePassword(data.password)) {
      tempErrors.password =
        "Password must be at least 8 characters and include uppercase, lowercase, digit, and special character.";
    }
  if (!data.admin_access.length)
    tempErrors.admin_access = "Select at least one access";

  // 🔑 Password validation:
  if (!retrievedata?.id) {
    // Add mode → password required
    if (!data.password.trim()) {
      tempErrors.password = "Password is required";
    } else if (data.password && !validatePassword(data.password)) {
      tempErrors.password =
        "Password must be at least 8 characters long and include an uppercase, lowercase, digit, and special character.";
    }
  } else {
    // Edit mode → password optional
    if ( data.password != "" && data.password && data.password.trim().length > 0 && !validatePassword(data.password)) {
      tempErrors.password =
        "Password must be at least 8 characters long and include an uppercase, lowercase, digit, and special character.";
    }
  }

  setErrors(tempErrors);
  return Object.keys(tempErrors).length === 0;
};

const handleSave = () => {
  if (validateForm()) {
    let Response_data = { ...data };

    if (retrievedata?.id) {
      // Response_data.id = retrievedata.id;

      if (!data.password.trim()) {
        delete Response_data.password;
      }
    }


    dispatch(resetMasterdashData_Crud_opretions({
        payload: { method: retrievedata?.id ? "edit":"create", id: retrievedata?.id, data:Response_data , 
        Funcations: () => {
         setShow(false)
        },

              listParams: {
        search,
        page_size: 20,
        page: dtpageindex,
      },
 

         }
    }))
  }
};




  return (
    <div>
      <Modal show={show}  size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Admin Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {/* First Name */}
            <div className="col-sm-3">
              <label 
                                                class="form-label"

              >First Name 
                
                 <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="first_name"
                value={data.first_name}
                onChange={HandleChanges}
              />
              {errors.first_name && (
                <p className="Errors_">{errors.first_name}</p>
              )}
            </div>

            {/* Last Name */}
            <div className="col-sm-3">
              <label                                   class="form-label"
>Last Name

                 <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="last_name"
                value={data.last_name}
                onChange={HandleChanges}
              />
              {errors.last_name && (
                <p className="Errors_">{errors.last_name}</p>
              )}
            </div>

            {/* Email */}
            <div className="col-sm-6">
              <label                                   class="form-label"
>Email

                 <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={data.email}
                onChange={HandleChanges}
              />
              {errors.email && <p className="Errors_">{errors.email}</p>}
            </div>

            {/* Password */}
            <div className="col-sm-6 mt-3">
              <label                                   class="form-label"
>
                Password <span style={{ color: "red" }}>*</span>
              </label>
              <div className="Password-Filed" style={{ position: "relative" }}>
                <input
                  type={viewpass ? "text" : "password"}
                  className={`form-control ${
                    viewpass ? "activate" : "notactivate"
                  }`}
                  required
                  autoComplete="off"
                  value={data.password}
                  name="password"
                  onChange={HandleChanges}
                />
                <i
                  className="icon"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "10px",
                    cursor: "pointer",
                  }}
                >
                  {viewpass ? (
                    <RemoveRedEyeIcon onClick={() => setViewpass(!viewpass)} />
                  ) : (
                    <VisibilityOffIcon
                      onClick={() => setViewpass(!viewpass)}
                    />
                  )}
                </i>
              </div>
              {errors.password && (
                <p className="Errors_">{errors.password}</p>
              )}
            </div>

            {/* Access List */}
            <div className="col-sm-6 mt-3">
              <label                                   class="form-label"
>Access List
<span style={{ color: "red" }}>*</span>
</label>
              <Multiselect
                options={optionsForAdmin}
                selectedValues={selectedOptions}
                onSelect={handleChange}
                onRemove={handleChange}
                displayValue="name"
                placeholder=""
              />
              {errors.admin_access && (
                <p className="Errors_">{errors.admin_access}</p>
              )}
            </div>

<div className="col-sm-3 mt-3">
  <label className="form-label">Active Status</label>
  <div className="form-check form-switch">
    <input
      className="form-check-input"
      type="checkbox"
      name="is_active"
      checked={data.is_active}
      onChange={(e) =>
        setData((prev) => ({
          ...prev,
          is_active: e.target.checked,
        }))
      }
    />
    <label className="form-check-label">
      {data.is_active ? "Active" : "Inactive"}
    </label>
  </div>
</div>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="#ef4d39" style={{background:"#e98478", color:"#fff"}} onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button variant="#ef4d39" style={{background:"#ef4d39", color:"#fff"}} onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
